// VanStockBadge - Visual indicator for van stock products
import { Package } from 'lucide-react'

export interface VanStockBadgeProps {
  className?: string
  size?: 'xs' | 'sm' | 'md'
}

export function VanStockBadge({ className = '', size = 'md' }: VanStockBadgeProps) {
  const sizeClasses = {
    xs: 'px-1.5 py-0.5 text-[10px] gap-1',
    sm: 'px-2 py-1 text-xs gap-1',
    md: 'px-2.5 py-1.5 text-sm gap-1.5',
  }

  const iconSizes = {
    xs: 'w-2.5 h-2.5',
    sm: 'w-3 h-3',
    md: 'w-3.5 h-3.5',
  }

  return (
    <span
      className={`inline-flex items-center ${sizeClasses[size]} bg-violet-100 text-violet-700 border border-violet-200 rounded-md font-medium ${className}`}
    >
      <Package className={iconSizes[size]} />
      <span>Van stock</span>
    </span>
  )
}
